import { Action } from "../../common/actions/core/action";
import ActionDispatcherService from "../../common/actions/core/action-dispatcher.service";
import { ActionHandler } from "../../common/actions/core/action-handler";
import { LanguageChangeAction } from "../../common/actions/language.action";


export default abstract class LanguageChangeController implements ActionHandler {
    private registeredInActionDispatcher;

    constructor(
        protected actionDispatcher: ActionDispatcherService,
    ) { }

    public $onInit() {
        this.actionDispatcher.register(this);
        this.registeredInActionDispatcher = true;
    }

    public $postLink() {
        this.resetPackageNames();
    }

    public $onDestroy() {
        if (this.registeredInActionDispatcher) {
            this.actionDispatcher.unregister(this);
        }
    }

    public handle(action: Action) {
        if (action instanceof LanguageChangeAction && action.reloadAuthData) {
            this.resetPackageNames();
        }
    }

    protected abstract resetPackageNames();
}


// WEBPACK FOOTER //
// src/app/no-auth/services/language-change.controller.ts